import resolveNumberValue from '../../DatasetExport/utils/resolveNumberValue';

/**
 * Numeric value of a cell, or undefined when the cell holds no value at all.
 *
 * resolveNumberValue parses an empty string as 0 (Number('') === 0), which is
 * fine for a sum but silently drags an average down and would turn a blank row
 * into a zero group in a VAT breakdown. Reports must not invent zeros, so
 * empty and whitespace-only values are rejected before parsing.
 */
export const resolveOptionalNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return undefined;
  }

  return resolveNumberValue(value);
};
